'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChangeSlideButton = function (_Component) {
    (0, _inherits3.default)(ChangeSlideButton, _Component);

    function ChangeSlideButton(props, context) {
        (0, _classCallCheck3.default)(this, ChangeSlideButton);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ChangeSlideButton.__proto__ || (0, _getPrototypeOf2.default)(ChangeSlideButton)).call(this, props, context));

        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(ChangeSlideButton, [{
        key: 'onClick',
        value: function onClick() {
            var _props$carousel = this.props.carousel,
                onSlideChange = _props$carousel.onSlideChange,
                currentSlide = _props$carousel.currentSlide;
            var type = this.props.type;

            var direction = type === 'next' ? 1 : -1;
            onSlideChange(currentSlide + direction);
        }
    }, {
        key: 'isAtEdge',
        value: function isAtEdge() {
            var _props$carousel2 = this.props.carousel,
                currentSlide = _props$carousel2.currentSlide,
                totalSlides = _props$carousel2.totalSlides;
            var type = this.props.type;


            switch (type) {
                case 'next':
                    return currentSlide === totalSlides - 1;
                case 'previous':
                    return currentSlide === 0;
                default:
                    return false;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames;

            var _props = this.props,
                carousel = _props.carousel,
                children = _props.children,
                className = _props.className,
                type = _props.type,
                disabled = _props.disabled;
            var totalSlides = carousel.totalSlides,
                infinite = carousel.infinite,
                theme = carousel.theme;


            if (totalSlides <= 1) {
                return null;
            }

            var classNames = (0, _classnames3.default)(className, theme.changeSlideButton, (_classnames = {}, (0, _defineProperty3.default)(_classnames, theme.changeSlideButtonDisabled, disabled || !infinite && this.isAtEdge()), (0, _defineProperty3.default)(_classnames, theme.previousSlideButton, type === 'previous'), (0, _defineProperty3.default)(_classnames, theme.nextSlideButton, type === 'next'), _classnames));
            return _react2.default.createElement(
                'button',
                {
                    className: classNames,
                    onClick: this.onClick,
                    disabled: disabled
                },
                children || (type === 'next' ? '>' : '<')
            );
        }
    }]);
    return ChangeSlideButton;
}(_react.Component);

ChangeSlideButton.propTypes = {
    className: _propTypes2.default.string,
    children: _propTypes2.default.node,
    carousel: _propTypes2.default.shape({
        theme: _propTypes2.default.shape({
            changeSlideButton: _propTypes2.default.string,
            changeSlideButtonDisabled: _propTypes2.default.string,
            previousSlideButton: _propTypes2.default.string,
            nextSlideButton: _propTypes2.default.string
        }),
        infinite: _propTypes2.default.bool.isRequired,
        totalSlides: _propTypes2.default.number.isRequired,
        currentSlide: _propTypes2.default.number.isRequired,
        onSlideChange: _propTypes2.default.func.isRequired
    }).isRequired,
    type: _propTypes2.default.oneOf(['next', 'previous']).isRequired,
    disabled: _propTypes2.default.bool.isRequired
};
ChangeSlideButton.defaultProps = {
    className: undefined,
    children: undefined
};
exports.default = ChangeSlideButton;
//# sourceMappingURL=ChangeSlideButton.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-carousel/lib/cjs/ChangeSlideButton/ChangeSlideButton.js
 ** module id = 584
 ** module chunks = 1
 **/